import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './styles/global.css'
import { Header, Hero, DemoSection, FeatureList, CTA, Install, APIDoc, Footer } from './components/Landing'

function LandingPage() {
  return (
    <>
      <Hero />
      <DemoSection />
      <FeatureList />
      <Install />
      <CTA />
    </>
  )
}

function APIPage() {
  return <APIDoc />
}

function App() {
  return (
    <BrowserRouter>
      <div className="landing-page">
        <Header />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/api" element={<APIPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
